import React from 'react';
import PropTypes from 'prop-types';

import Img from '../../Img';

import styles from './ratingInfo.scss';
import { ratingTypes } from '../../../utils/constants';

const RatingInfoContent = props => {
    const { isMobile, cancelText, closePopUp } = props;
    return (
        <div className="pop-up-content">
            <div className={styles.titleWrapper}>
                <div className={styles.title}>{ratingTypes.tennis} Rating</div>
                {!isMobile && (
                    <Img
                        alt="close"
                        src="/img/v2/icons/icon-close.svg"
                        className={styles.closeIcon}
                        onClick={closePopUp}
                    />
                )}
            </div>
            <div className="row mb24">
                <div className="col">
                    <div className={styles.descTitle}>
                        Verified {ratingTypes.tennis} Rating
                    </div>
                    <div className={styles.desc}>
                        When you see the Verified check mark the rating is from results coming from organized events.
                    </div>
                </div>
            </div>
            <div className="row mb24">
                <div className="col">
                    <div className={styles.descTitle}>
                        {ratingTypes.tennis} Rating
                    </div>
                    <div className={styles.desc}>
                        The {ratingTypes.tennis} rating reflects results from a broader range of event types, including self-posted scores, casual play, verified matches, and practice matches.
                    </div>
                </div>
            </div>
            <div className="row mb24">
                <div className="col">
                    <div className={styles.descTitle}>
                        Projected {ratingTypes.tennis} Rating
                    </div>
                    <div className={styles.desc}>
                        When you see “Projected” then it means there are not yet enough results to have full confidence in the rating but there are enough results to display a projection. Approximately 4-6 results are needed before a rating becomes reliable.
                    </div>
                </div>
            </div>
            <div className="row mb24">
                <div className="col">
                    <div className={styles.descTitle}>
                        Estimated {ratingTypes.tennis} Rating
                    </div>
                    <div className={styles.desc}>
                        If you see a range then it is an estimate of your {ratingTypes.tennis} Rating based on the answers you provided about your tennis ability.
                    </div>
                </div>
            </div>
            <div className="row mb24">
                <div className="col">
                    <div className={styles.descTitle}>
                        Last known rating
                    </div>
                    <div className={styles.desc}>
                        This is the last known fully reliable rating for the player from within the last 2 years.
                    </div>
                </div>
            </div>
            <div className="row mb24">
                <div className="col">
                    <div className={styles.descTitle}>
                        Color Ball Rating
                    </div>
                    <div className={styles.desc}>
                        This rating reflects results from Red, Orange, and Green ball matches / events. The rating is split into groups by ball color: Red (R1), Orange (O1 or O2), and Green Ball (G1, G2, or G3).
                        <br /><br />
                        <a
                            href="https://support.utrsports.net/en/support/solutions/articles/9000220772-progression-ball-australia"
                            onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                window.open(
                                    e.currentTarget.href,
                                    '_blank',
                                    'noopener,noreferrer',
                                );
                            }}
                        >
                            Click here
                        </a> to learn more.
                    </div>
                </div>
            </div>
            <div className="row mb40">
                <div className="col">
                    <div className={styles.descTitle}>
                        Unrated
                    </div>
                    <div className={styles.desc}>
                        If you see Unrated it means the player hasn&apos;t had any results for a rating to be generated in the past year.
                    </div>
                </div>
            </div>
            <div className="row mb40">
                <div className="col">
                    <div className={styles.descTitle}>
                        Reliability
                    </div>
                    <div className={styles.desc}>
                        The Reliability bar is a measure of confidence in the {ratingTypes.tennis} Rating. A full bar indicates that the player has played enough matches to have a reliable {ratingTypes.tennis} Rating.
                    </div>
                </div>
            </div>
            <div className="row mb24">
                <div className="col-12 text-center">
                    See <a
                        href="https://support.utrsports.net/en/support/solutions/articles/9000151830-understanding-the-algorithm-complete-summary"
                        onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                window.open(
                                    e.currentTarget.href,
                                    '_blank',
                                    'noopener,noreferrer',
                                );
                            }}
                    >
                            Understanding the Algorithm
                        </a> to learn more.
                </div>
            </div>
            <div className="text-right">
                <button
                    type="button"
                    onClick={closePopUp}
                    className={`btn btn-primary text-uppercase text-white`}
                >
                    <span>{cancelText}</span>
                </button>
            </div>
        </div>
    );
};

RatingInfoContent.propTypes = {
    isMobile: PropTypes.bool.isRequired,
    cancelText: PropTypes.string.isRequired,
    closePopUp: PropTypes.func.isRequired,
};

export default RatingInfoContent;
